<div class="billing-portal">
  <div class="modal-header content-space-between">
    <h5 class="modal-title">{{ "common.topBar.billingAndInvoices" | transloco }}</h5>

    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>

  <div class="billing-portal__body">
    <iframe
      class="billing-portal__frame"
      [src]="safeUrl"
      title="{{ 'common.topBar.billingAndInvoices' | transloco }}"
    ></iframe>
  </div>
</div>
